import React, { useEffect, useState } from "react";
import api, { rupee } from "../../lib/api";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, CartesianGrid } from "recharts";

const COLORS = ["#C5A059", "#0F172A", "#1B2540", "#E4CB94", "#9CA3AF"];

export default function AdminAnalytics() {
  const [a, setA] = useState(null);
  useEffect(() => { api.get("/admin/analytics").then((r) => setA(r.data)); }, []);
  if (!a) return <div className="text-muted-foreground">Loading analytics...</div>;

  const Stat = ({ label, value }) => (
    <div className="bg-white rounded-xl border border-black/5 p-5"><div className="text-xs text-muted-foreground uppercase tracking-wide">{label}</div><div className="font-serif text-2xl text-navy mt-1">{value}</div></div>
  );

  return (
    <div data-testid="admin-analytics">
      <h1 className="font-serif text-3xl text-navy mb-6">Analytics</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <Stat label="Avg Order Value" value={rupee(a.average_order_value)} />
        <Stat label="Items / Order" value={a.items_per_order} />
        <Stat label="Cancellation Rate" value={`${a.cancel_rate}%`} />
        <Stat label="Repeat Customers" value={a.repeat_customers} />
        <Stat label="Total Customers" value={a.total_customers} />
        <Stat label="Total Leads" value={a.leads_total} />
        <Stat label="Leads Converted" value={a.leads_converted} />
        <Stat label="Conversion Rate" value={`${a.conversion_rate}%`} />
      </div>
      <div className="grid lg:grid-cols-2 gap-5 mb-6">
        <div className="bg-white rounded-xl border border-black/5 p-5">
          <h3 className="font-serif text-xl text-navy mb-4">Top Products (by sales)</h3>
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={a.top_products} layout="vertical"><CartesianGrid strokeDasharray="3 3" stroke="#eee" /><XAxis type="number" fontSize={11} allowDecimals={false} /><YAxis type="category" dataKey="name" width={130} fontSize={10} /><Tooltip /><Bar dataKey="sold" fill="#C5A059" radius={[0, 4, 4, 0]} /></BarChart>
          </ResponsiveContainer>
        </div>
        <div className="bg-white rounded-xl border border-black/5 p-5">
          <h3 className="font-serif text-xl text-navy mb-4">Leads by Source</h3>
          {a.leads_by_source.length === 0 ? <div className="text-sm text-muted-foreground py-10 text-center">No leads yet</div> : (
            <ResponsiveContainer width="100%" height={280}>
              <PieChart><Pie data={a.leads_by_source} dataKey="count" nameKey="source" cx="50%" cy="50%" outerRadius={90} label={(e) => e.source}>{a.leads_by_source.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}</Pie><Tooltip /></PieChart>
            </ResponsiveContainer>
          )}
        </div>
      </div>
      <div className="bg-white rounded-xl border border-black/5 p-5">
        <h3 className="font-serif text-xl text-navy mb-4">Most Viewed Products</h3>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {a.most_viewed.map((p, i) => <div key={i} className="bg-beige rounded-lg px-4 py-3 flex justify-between"><span className="text-sm text-navy truncate">{p.name}</span><span className="text-sm font-semibold text-gold">{p.views}</span></div>)}
        </div>
      </div>
    </div>
  );
}
